/*
 * @Author: yanyongchao
 * @Date: 2018-12-26 13:41:39
 * type : Toast 的位置. | String | 默认: 'bottom' | 可选值 'top, center,bottom'
 * duration : Number | 默认 2500ms
 * wordWrap : 是否自动换行. | Boolean | 默认: false
 * width : Toast 的宽度. | String | 默认: 'auto'
 */
import Vue from 'vue'
// 全局注册FbToast插件
// import '@/components/FbToast/toast.css'
import Toast from '@/components/FbToast'

Vue.use(Toast, {
  type: 'center',
  duration: 3000,
  wordWrap: true
})
